import { render, staticRenderFns } from "./WarningIcon.vue?vue&type=template&id=fd48c680&scoped=true"
var script = {}
import style0 from "./WarningIcon.vue?vue&type=style&index=0&id=fd48c680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd48c680",
  null
  
)

export default component.exports